import { useAuth } from '../context/AuthContext';

// Admin → /admin · logged-in member → /area-clienti · visitor → /
export const useBackendHome = () => {
  const { user } = useAuth();
  if (user?.role === 'admin') return { path: '/admin', label: 'Pannello Admin' };
  if (user) return { path: '/area-clienti', label: 'Area Clienti' };
  return { path: '/', label: 'Home' };
};
